export interface PbxFeatureFlagService {
  readonly context: string
  readonly feature: PbxAvailableFeatureFlags
  readonly isDefault: boolean
  readonly setting: PbxFeatureFlagSetting
}

export enum PbxAvailableFeatureFlags {
  MEETINGS = 'jiveweb.meetings',
  STANDARD = 'jiveweb.standard',
  MESSAGING = 'jiveweb.messaging',
  RESOLVE = 'admin.helpdesk-management.dashboard',
}

export enum PbxFeatureFlagSetting {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
